import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../components/layout/MainLayout.vue'
import DashboardAssist from '../views/DashboardAssist.vue'
import DashboardComptable from '../views/DashboardComptable.vue'
import Factures from '../views/Factures.vue'
import Contrats from '../views/Contrats.vue'
import Alertes from '../views/Alertes.vue'
import Biens from '../views/Biens.vue'
import Clients from '../views/Clients.vue'
import GestionBiens from '../views/GestionBiens.vue'
import authService from '../services/authService'

const routes = [
  { 
    path: '/', 
    name: 'Login', 
    component: Login,
    meta: { 
      requiresAuth: false,
      redirectIfAuthenticated: true
    }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard-assist', name: 'DashboardAssist', component: DashboardAssist, alias: '' },
      { path: 'dashboard-comptable', name: 'DashboardComptable', component: DashboardComptable },
      { path: 'factures', name: 'Factures', component: Factures },
      { path: 'contrats', name: 'Contrats', component: Contrats },
      { path: 'alertes', name: 'Alertes', component: Alertes },
      { path: 'biens', name: 'Biens', component: Biens },
      { path: 'clients', name: 'Clients', component: Clients },
      { path: 'gestion-biens', name: 'GestionBiens', component: GestionBiens }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guards for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = authService.isAuthenticated();
  
  // For routes requiring authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      next({ name: 'Login' });
    } else {
      next(); // Allow navigation
    }
  } 
  // For login page - redirect to dashboard-assist if already authenticated
  else if (to.matched.some(record => record.meta.redirectIfAuthenticated) && isAuthenticated) {
    next({ path: '/dashboard-assist' });
  } 
  // For all other routes
  else {
    next(); // Allow navigation
  }
});

export default router 